import {
    AbstractRestrictionsService,
    RESTRICTION_IP_DEVICE,
    RESTRICTION_TRIGGERS,
    RESTRICTION_ZONES,
    RestrictionsServiceState,
} from 'app/licensing/restriction_service_interface';

export function isIPDevicesEnabled(restrictionServiceState: RestrictionsServiceState): boolean {
    return isRestrictionEnabled(restrictionServiceState, RESTRICTION_IP_DEVICE);
}

export function isTriggersEnabled(restrictionServiceState: RestrictionsServiceState): boolean {
    return isRestrictionEnabled(restrictionServiceState, RESTRICTION_TRIGGERS);
}
export function isZonesEnabled(restrictionServiceState: RestrictionsServiceState): boolean {
    return isRestrictionEnabled(restrictionServiceState, RESTRICTION_ZONES);
}

/**
 * Helper, it's ENABLED, if it's not hidden and not disabled
 */
function isRestrictionEnabled(
    restrictionServiceState: RestrictionsServiceState,
    restrictionKey: keyof RestrictionsServiceState,
): boolean {
    const restrictionState = AbstractRestrictionsService.get(
        restrictionServiceState?.[restrictionKey],
    );
    return !restrictionState.disabled && !restrictionState.hidden;
}
